<template>
	<section class="bg-white">
		<div class="bg-cover bg-top rvready-header">
			<div class="container mx-auto px-2 py-4">
				<div class="hidden sm:block py-8">
					<h1 class="font-extrabold text-4xl text-center leading-tight mx-auto md:text-5xl md:max-w-xl lg:max-w-full lg:text-4xl xl:text-5xl">{{ text }}</h1>
				</div>
				<slot></slot>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		props: {
			text: {
				required: true,
				type: String,
			},
		},
	}
</script>

<style>
	.rvready-header {
		background-image: url('/rvready/header/mobile.jpg');
	}

	@screen sm {
		.rvready-header {
			background-image: url('/rvready/header/sm.jpg');
		}
	}

	@screen md {
		.rvready-header {
			background-image: url('/rvready/header/md.jpg');
		}
	}

	@screen lg {
		.rvready-header {
			background-image: url('/rvready/header/lg.jpg');
		}
	}

	@screen xl {
		.rvready-header {
			background-image: url('/rvready/header/xl.jpg');
		}
	}
</style>
